import React, { useState } from "react";
import { Link } from "react-router-dom";

const FilterPill = ({
  pendingApproval,
  setfilter,
  filter,
  apiRequest,
  setApiRequest,
  setMethod,
  onChange,
}) => {
  return (
    <div>
      <form name="myform" className="form">
        <div className="optionsDiv border-filter" style={{ width: "100%" }}>
          <input
            type="radio"
            id={pendingApproval.label}
            className="optionBtn"
            name={"radioButton"}
            value={pendingApproval.label}
            checked={filter == pendingApproval.label}
            onChange={(e) => {
              onChange();
            }}
          />
          <label className={"optionLabel"} for={pendingApproval.label}>
            {`${pendingApproval.count} -  ${pendingApproval.label}`}
          </label>
        </div>{" "}
      </form>
    </div>
  );
};

export default FilterPill;
